(()=>{
function init(root=document){
 root.querySelectorAll('[data-product-section]').forEach(section=>{
  if(section.dataset.ready)return;section.dataset.ready='true';
  const image=section.querySelector('#ProductImage');
  section.querySelectorAll('[data-gallery-src]').forEach(button=>button.addEventListener('click',()=>{
   if(!image)return;image.removeAttribute('srcset');image.src=button.dataset.gallerySrc;image.alt=button.dataset.galleryAlt;
   section.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  }));
  const select=section.querySelector('[data-variant-select]');
  if(select)select.addEventListener('change',()=>{
   const o=select.selectedOptions[0];if(!o)return;
   section.querySelector('[data-price]').textContent=o.dataset.price;
   const compare=section.querySelector('[data-compare]');compare.textContent=o.dataset.compare;compare.hidden=!o.dataset.compare;
   const add=section.querySelector('[data-add-button]');add.disabled=o.dataset.available!=='true';add.textContent=add.disabled?add.dataset.soldLabel:add.dataset.addLabel;
   if(image&&o.dataset.image){image.removeAttribute('srcset');image.src=o.dataset.image;}
   const url=new URL(location.href);url.searchParams.set('variant',o.value);history.replaceState({},'',url);
  });
 });
}
init();document.addEventListener('shopify:section:load',()=>init());
document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.mobile-nav[open]').forEach(x=>x.removeAttribute('open'));});
document.addEventListener('click',e=>{document.querySelectorAll('.mobile-nav[open]').forEach(x=>{if(!x.contains(e.target))x.removeAttribute('open');});});
})();
